import Boot from './src/boot';

export const wrapRootElement = Boot;
